<div class="card-container">
  <div class="custom-card">
    <div class="icon">
      <mat-icon class="icon-display">task_alt</mat-icon>
    </div>

    <div class="text-big">Onboard success!!</div>
    <div class="text-small">
      Please return back to the other tab. And click the button [Check onboard].
    </div>

  </div>
</div>
